import { styled } from "styled-components";
import ReactModal from "react-modal";
import Icon from "../Icon";

ReactModal.setAppElement("#root");

const StyledModal = styled(ReactModal)`
    position: absolute;
    top: 4px;
    left: 4px;
    right: 4px;
    bottom: 4px;
    background-color: color(from var(--d8s-overlay) srgb r g b / 0.95);
		
    .modal-close {
        position: absolute;
        right: 0;
        cursor: pointer;
    }
`;

export const ModalContent = styled.div`
    width: 100%;
    height: calc(100% - 10px);
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
    align-items: center;
    color: #FFF;
`;

const Modal = ({
	               children,
	               isOpen = true,
	               onOpen = null,
	               onClose = null,
	               className,
               }) => {
	const onButtonClose = () => {
		onClose?.({ reason: "close-button" });
	};

	const onModalClose = () => {
		onClose?.({ reason: "modal" });
	};

	return (
		<StyledModal
			isOpen={isOpen}
			onAfterOpen={onOpen}
			onRequestClose={onModalClose}
			className={className}
			overlayClassName="modal-overlay"
			style={{
				overlay: {
					//appear over hotspots
					zIndex: 9999,
					backgroundColor: "transparent"
				}
			}}
		>
			{/*<IoCloseSharp className="modal-close" size="32" onClick={onButtonClose}/>*/}
			<Icon icon="close" className="modal-close" size={40} onClick={onButtonClose} fill="#FFF"/>
			<ModalContent>
				{children}
			</ModalContent>
		</StyledModal>
	);
};

export default Modal;
